export const DiscountType = {
  Relative: 'relative',
  Absolute: 'absolute',
  Fixed: 'fixed',
  GiftLineItem: 'giftLineItem',
  Shipping: 'shipping',
} as const;

// eslint-disable-next-line no-redeclare
export type DiscountType = ValueOf<typeof DiscountType>

export type DiscountTarget =
  | 'lineItems'
  | 'multiBuyLineItems'
  | 'customLineItems'
  | 'multiBuyCustomLineItems'
  | 'shipping'
  | null;

export interface MappedDiscount {
  id: string;
  name: string;
  type: DiscountType;
  target: DiscountTarget;
  value: number;
  code?: string;
  discountedAmount: number;
  requiresDiscountCode: boolean;
}

export type VolumeDiscount = { volume: number, discountPercentage: number };

export type VolumeDiscountRaw = {
  key: string,
  id: string,
  isActive: boolean,
  value?: {
    type: string,
    permyriad?: number
  },
  target?: {
    type: string,
    predicate?: string
  }
}

export type VolumeDiscountGroups = Record<string, VolumeDiscount[]>;

export type DiscountData = {
  cartDiscounts: {
    results: VolumeDiscountRaw[]
  }
}

export type PersonalizedDiscount = {
  cartDiscount: VolumeDiscountRaw
}
